import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type RootState } from '../../../../app/store'

export interface UnlinkAction {
  instructionId: number
  checked: boolean
}
export interface DisbursementsModuleState {
  // currentDisbursementBatchId: number | null
  showAllBatches: boolean
  unlinkActions: UnlinkAction[]
}

const initialState: DisbursementsModuleState = {
  // currentDisbursementBatchId: null
  showAllBatches: false,
  unlinkActions: []
}

export const disbursementsSlice = createSlice({
  name: 'disbursementsSlice',
  initialState,
  reducers: {
    // setCurrentDisbursementBatchId: (state, action: PayloadAction<number>) => {
    //   state.currentDisbursementBatchId = action.payload
    // }
    setShowAllBatches: (state, action: PayloadAction<boolean>) => {
      state.showAllBatches = action.payload
    },
    setUnlinkActions: (state, action: PayloadAction<UnlinkAction[]>) => {
      state.unlinkActions = action.payload
    }

  }
})

export const {
  // setCurrentDisbursementBatchId
  setShowAllBatches,
  setUnlinkActions
} = disbursementsSlice.actions

// export const selectCurrentDisbursementBatchId = (state: RootState): number | null => state.disbursementsSlice.currentDisbursementBatchId
export const selectShowAllBatches = (state: RootState): boolean => state.disbursementsSlice.showAllBatches
export const selectUnlinkActions = (state: RootState): UnlinkAction[] => state.disbursementsSlice.unlinkActions

export default disbursementsSlice.reducer
